<template>
    <div  :style="{'height':clientHeight-90+'px'}">
<!--        <div class="card-header">-->
<!--            <h5>班主任续班数据</h5>-->
<!--        </div>-->
        <vue-scroll :ops="$ops">
        <div >
            <div class="m-portlet m-b-10">
                <div class="m-portlet__body">
                    <el-form>
                        <el-form-item label="选择学期">
                            <el-select v-model="semesterType_id" clearable placeholder="请选择学期" filterable remote
                                       @change="changeSemesterType()">
                                <el-option
                                        v-for="item in semesterTypes"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="m-portlet m-b-0">
                <div class="m-portlet__body" v-loading="loading">
                    <el-table
                            :data="orderHeadTeachers"
                            style="width: 100%"
                            size="middle">
                        <el-table-column prop="name" label="班主任"></el-table-column>
                        <el-table-column>
                            <template slot="header" slot-scope="scope">
                                    {{oneSemesterType.name}}
                            </template>
                            <el-table-column prop="oneSemesterHeadTeacherStudent_number" label="报班的学生数" ></el-table-column>
                            <el-table-column prop="avagOneSemesterHeadTeacherStudentClassesNumber" label="平均报班数" ></el-table-column>
                            <el-table-column prop="oneSemesterThreeClassHeadTeacherStudent_number" label="报班数大于等于三门的学生数" > </el-table-column>
                            <el-table-column prop="oneSemesterNotThreeClassHeadTeacherStudent_number" label="报班数小于三名的学生数" > </el-table-column>
                        </el-table-column>
                        <el-table-column>
                            <template slot="header" slot-scope="scope" style="text-align: center">
                                {{twoSemesterType.name}}
                            </template>
                            <el-table-column prop="twoSemesterHeadTeacherStudent_number" label="报班的学生数" ></el-table-column>
                            <el-table-column prop="avagtwoSemesterHeadTeacherStudentClassesNumber" label="平均报班数" ></el-table-column>
                            <el-table-column prop="twoSemesterThreeClassHeadTeacherStudent_number" label="报班数大于等于三门的学生数" > </el-table-column>
                            <el-table-column prop="twoSemesterNotThreeClassHeadTeacherStudent_number" label="报班数小于三名的学生数" > </el-table-column>
                        </el-table-column>
                        <el-table-column prop="bothSemester_squareRoot">
                            <template slot="header" >
                                两学期报班差的平方平均数
                                <el-popover
                                        placement="top"
                                        trigger="hover"
                                        width="250"
                                        content="√￣[[∑[(W₁-S₁)]²/n]">
                                    <el-button slot="reference" icon="el-icon-info" type="text" circle></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bothSemesterDiffer_sum_avag">
                            <template slot="header" >
                                两学期已续班学生报班差的平均数
                                <el-popover
                                        placement="top"
                                        trigger="hover"
                                        width="250"
                                        content="aw_avag=(∑(A₁-W₁))/n">
                                    <el-button slot="reference" icon="el-icon-info" type="text" circle></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bothSemester_squareRoot">
                            <template slot="header" >
                                两学期已续班学生报班离散度
                                <el-popover
                                        placement="top"
                                        trigger="hover"
                                        width="250"
                                        content="√￣[[∑[(A₁-W₁)-aw_avag]²/n]">
                                    <el-button slot="reference" icon="el-icon-info" type="text" circle></el-button>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--分页-->
                    <div class="text-center m-t-10">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        </vue-scroll>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                path:"/renewalHeadTeacher/list",
                semesterTypes:[],
                semesterType_id:'',
                loading: true,
                headTeachers: [],
                date: '',
                start_date: '',
                end_date: '',
                oneSemesterType: '',
                twoSemesterType: '',
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            };
        },
        mounted() {
            this.$nextTick(() => {
            })
        },
        created() {
            this.semester_id=this.$store.state.config.nowSemester.id;
            this.handleIndex();
            this.handleShow();
            this.handleCreate();

        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            orderHeadTeachers: function () {
                return this._.values(this.headTeachers);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.semesterTypes =data.semesterTypes;
                        this.semester=3;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.oneSemesterType = data.oneSemesterType;
                        this.twoSemesterType = data.twoSemesterType;
                        this.headTeachers = data.headTeachers;
                        this.semesterType_id = data.oneSemesterType.id;
                        this.loading = false;
                        break;
                }
            },
            changeSemesterType(){
                this.loading = true;
                this.handleIndex();
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semesterType_id': this.semesterType_id,
                    'nowSemester_id': this.$store.state.config.nowSemester.id,
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>


<style scoped>

</style>
